<template>
  <el-form :rules="rules" ref="smtpForm" :model="smtp" label-width="50%" label-position="left">
    <el-form-item label="SMTP mail server :" prop="mail_server">
      <el-input style="width:70%" v-model="smtp.mail_server"/>
    </el-form-item>
    <el-form-item label="Use SMTP authentication:">
      <el-switch @change="authenticationChange" v-model="smtp.authentication"/>
    </el-form-item>
    <el-form-item label="User name:" prop="userName">
      <el-input :disabled="!smtp.authentication" style="width:70%" v-model="smtp.userName"/>
    </el-form-item>
    <el-form-item label="Password:" prop="password">
      <el-input type="password" v-model="smtp.password" style="width:70%"
                :disabled="!smtp.authentication || disablePassword">
        <el-button slot="append" type="primary" @click="togglePasswordChange" style="font-size:.6rem; ">change password
        </el-button>

      </el-input>
    </el-form-item>
    <el-form-item label="Port:" prop="port">
      <el-input v-model.number="smtp.port" style="width:20%"/>
    </el-form-item>
    <el-form-item label="Enable SMTP over SSL or TLS">
      <el-select v-model="smtp.protocol" placeholder="please a SMTP protocol">
        <el-option label="SSL" value="SSL"/>
        <el-option label="TLS" value="TLS"/>
      </el-select>
    </el-form-item>
    <el-form-item label="Test email :">
      <el-input v-model="testEmail"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" :loading='sendingTestEmail' :icon="sent?'el-icon-check':''" @click="sendTestEmail"> Send
        a test
        email
      </el-button>
    </el-form-item>


    <el-form-item>
      <el-button :loading="loading" type="primary" @click="configureSMTP">{{loading?'Saving':'Save'}}
      </el-button>
      <el-button type="warning" @click="$emit('closeDialog')">Cancel</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import {post} from '../../../../../API/cloudFunctions'

  export default {
    created() {
      if (this.$store.getters.smtpConfig) {
        this.smtp = this.$store.getters.smtpConfig;
      }
    },

    name: "smtp",
    data() {
      return {
        testEmail: '',

        smtp: {
          mail_server: '',
          authentication: false,
          userName: '',
          password: '',
          port: 2525,
          protocol: 'TLS'
        },
        rules: {
          mail_server: {required: true, message: 'Please provide a SMTP mail server!'},
          port: {required: true,},
          userName: {},
          password: {}

        },
        loading: false,
        disablePassword: true,
        sendingTestEmail: false,
        sent: false,
      }
    },
    methods: {
      authenticationChange(state) {
        if (state) {
          this.rules.userName = {required: true, message: 'User name is required!', trigger: 'change'};
          this.rules.password = {required: true, trigger: 'change'};
        } else {
          this.smtp.userName = '';
          this.smtp.password = '';
          this.rules.userName = {};
          this.rules.password = {};
        }
      },
      configureSMTP() {
        this.$refs.smtpForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            post('updateUser', {id: this.$store.getters.currentUser.id, updates: {smtp: this.smtp}}).then(success => {
              this.loading = false;
              this.$message({
                message: 'Congrats, SMTP  configured successfully.',
                type: 'success'
              });

            }).catch(error => {
              this.loading = false;
              this.$message({
                message: 'Oops, an error has occurred, error:', error,
                type: 'success'
              });

            })

          } else {
            return false
          }


        });


      },
      togglePasswordChange() {
        this.disablePassword = !this.disablePassword
      },
      sendTestEmail() {
        this.sendingTestEmail = true;
        this.sent = false
        post('sendTestEmail', {
          smtp: this.smtp, testEmail: this.testEmail
        }).then(success => {
          this.sendingTestEmail = false;
          this.sent = false;
          this.$message({message: 'your smtp configuration is working perfectly', type: 'success'})

        }).catch(error => {
          this.sendingTestEmail = false;
          this.$message({message: 'Oops,please check your SMTP  configuration!', type: 'error'})
        })
      }

    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/smtp/smtp.vue